<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>网站抓取监控</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      网站抓取监控
      <div class="title-btn">
        <el-button type="warning" plain @click="exportFile"
          v-if="$store.state.funcModuleArray.includes(1901050201)">导出</el-button>
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" size="small" label-suffix="：">
            <el-form-item label="状态筛选">
              <el-select v-model="connect_type" size="small" style="margin-right: 10px;margin-left: 10px;width: 100px;">
                <el-option label="全部" value="0"> </el-option>
                <el-option label="正常" value="1"> </el-option>
                <el-option label="异常" value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="抓取类型">
              <el-select v-model="scrap_type" placeholder="选择抓取类型">
                <el-option label="全部" value="0"></el-option>
                <el-option v-for="(value, key, index) in scrap" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-input v-model="search_text" class="search-text" size="small" placeholder="请输入编码或名称">
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div style="display: flex;
    justify-content: space-between;">
            <div class="table-tool">共{{ totalCount }}条</div>
            <div class="count_page">
              每页
              <el-select style="width:70px" v-model="page_size" @change="onSearch">
                <el-option label="20" value="20"></el-option>
                <el-option label="50" value="50"></el-option>
                <el-option label="100" value="100"></el-option>
              </el-select>
              条
            </div>
          </div>

          <el-table :data="tableData" v-loading="loading" style="width: 100%">
            <el-table-column prop="client_name" label="商业公司名称">
            </el-table-column>
            <el-table-column prop="website_address" label="网站">
            </el-table-column>

            <el-table-column prop="broker_code" label="档案客户编码">
            </el-table-column>
            <el-table-column prop="client_name" label="档案名称">
            </el-table-column>
            <el-table-column prop="cls_desc" label="档案类型">
            </el-table-column>

            <el-table-column prop="scrap_type" label="抓取类型">
              <template slot-scope="scope">
                <span>{{ scrap[scope.row.scrap_type] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="log_content" label="连接状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.log_content === '正常'">{{ scope.row.log_content }}</el-tag>
                <el-tag type="danger" v-if="scope.row.log_content !== '正常'">{{
                  scope.row.log_content
                  }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage > 1">
          <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
            :page-size="page_size" layout="total, prev, pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { showWebscrapLog } from "@/api/index";
import { exportWebScrapLog } from "@/api/export";
export default {
  name: "WebPeriodMonitoring",
  data: () => ({
    currentPage: 1,
    totalCount: 0,
    totalPage: 0,
    tableData: [],
    connect_type: "0",
    scrap_type: "0",
    search_text: "",
    loading: false,
    page_size: "20",
    scrap: {
      1: "网站抓取",
      2: "Web service"
    }
  }),
  created() {
    this._getList(1);
  },
  methods: {
    handleCurrentChange(val) {
      this._getList(val);
    },
    _getList(page) {
      let para = {
        connect_type: this.connect_type,
        scrap_type: this.scrap_type,
        search_text: this.search_text,
        page,
        page_size: this.page_size
      };
      this.loading = true;
      showWebscrapLog(para).then(res => {
        this.loading = false;
        if (0 === res.status) {
          this.tableData = res.data.list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    onSearch() {
      this._getList(1);
    },
    exportFile() {
      let parameter = {
        search_text: this.search_text,
        connect_type: this.connect_type,
        scrap_type: this.scrap_type,
        export: 1
      };
      console.log(parameter, "parameterparameterparameter");
      exportWebScrapLog(parameter);
    }
  }
};
</script>

<style scoped lang="scss">
.view-filter {
  margin-bottom: 20px;
}

.search-text {
  margin-right: 10px;
  width: 300px;
}

.count_page {
  margin: -10px 0 10px 0;
}
</style>
